import { render, staticRenderFns } from "./handelChange.vue?vue&type=template&id=220b1e54"
import script from "./handelChange.vue?vue&type=script&lang=js"
export * from "./handelChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports